import apiClient from './client';

// learning-cycle feedback capture (item ).

export type FlagFeedbackDisposition =
  | 'confirmed'
  | 'false_positive'
  | 'needs_review';

export interface FlagFeedback {
  id: string;
  triggered_flag_id: string;
  disposition: FlagFeedbackDisposition;
  note: string | null;
  created_by: string;
  created_at: string;
}

export interface MissedAbnormality {
  id: string;
  case_id: string;
  description: string;
  created_by: string;
  created_at: string;
}

export interface MissedAbnormalityListResponse {
  items: MissedAbnormality[];
  total: number;
}

/** Record / update a reviewer's disposition on a triggered flag.
 * POST /cases/{caseId}/triggered-flags/{flagId}/feedback.
 * Upsert: one disposition per user per flag. */
export async function submitFlagFeedback(
  caseId: string,
  flagId: string,
  disposition: FlagFeedbackDisposition,
  note?: string,
): Promise<FlagFeedback> {
  const { data } = await apiClient.post<FlagFeedback>(
    `/cases/${caseId}/triggered-flags/${flagId}/feedback`,
    { disposition, note: note ?? null },
  );
  return data;
}

/** Add a free-form note about an abnormality the AI missed on the case.
 * POST /cases/{caseId}/missed-abnormalities. */
export async function createMissedAbnormality(
  caseId: string,
  description: string,
): Promise<MissedAbnormality> {
  const { data } = await apiClient.post<MissedAbnormality>(
    `/cases/${caseId}/missed-abnormalities`,
    { description },
  );
  return data;
}

/** List missed-abnormality notes for a case.
 * GET /cases/{caseId}/missed-abnormalities. */
export async function listMissedAbnormalities(
  caseId: string,
): Promise<MissedAbnormalityListResponse> {
  const { data } = await apiClient.get<MissedAbnormalityListResponse>(
    `/cases/${caseId}/missed-abnormalities`,
  );
  return data;
}